import axios from "axios";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import ValidationError from "../../ZodError";
import { PortfolioPlanResponse } from "../types";
export const portfolioPlanURL = () => environment() === "PROD"
    ? "https://middleware.prod.farther.com/investment/portfolio-plans"
    : "https://middleware.uat.farther.com/investment/portfolio-plans";
export const getPortfolioPlans = async (params, config) => {
    const { data } = await axios.get(portfolioPlanURL(), {
        headers: {
            version: "20240912",
            Authorization: `Bearer ${config.jwt}`,
            ...("clientId" in config && { Client: config.clientId }),
            ...("advisorId" in config && { Advisor: config.advisorId }),
        },
        params,
        paramsSerializer: {
            indexes: null,
        },
    });
    const decoded = PortfolioPlanResponse.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `[getPortfolioPlans.ts] received unexpected data`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
};
//# sourceMappingURL=getPortfolioPlans.js.map